<!-- src/App.vue -->
<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
html {
  scrollbar-gutter: stable;
}

body {
  overflow-y: scroll;
}
</style>
